import { Box, Flex, Image, useMantineTheme } from '@mantine/core';
import {
  BurgerComponet,
  Chicken,
  clamorlogo,
  Drinks,
  FoodDelivery,
  FoodOffers,
  Pizza,
  PrepareOrder,
  Sparkle,
} from '../assets';
import TagLine from '../ui/Icons/TagLine';
import { useMediaQuery } from '@mantine/hooks';
import DotIcon from '../ui/Icons/DotIcon';
import CircleIcon from '../ui/Icons/CircleIcon';

const Landing = () => {
  const mantinetheme = useMantineTheme();
  const mobile = useMediaQuery(`(max-width: ${mantinetheme.breakpoints.sm})`);
  const isSmall = useMediaQuery(`(max-width: 480px`);
  return (
    <Box className='landing-wrapper'>
      <Flex justify='flex-start' pos='absolute' top={0} w='100%' h='100%' className='image-wrapper'>
        <Box
          h='80%'
          w='50%'
          style={{
            position: 'relative',
            background: '#fac214',
            borderBottomRightRadius: mobile ? '80%' : '50%',
          }}>
          {!mobile && (
            <BurgerComponet
              style={{
                position: 'absolute',
                top: '20px',
                left: '20px',
              }}
            />
          )}

          {!mobile && (
            <FoodOffers
              style={{
                position: 'absolute',
                bottom: '140px',
                right: '120px',
                transform: 'rotate(-30deg)',
              }}
            />
          )}

          <Pizza
            style={{
              position: 'absolute',
              bottom: '140px',
              left: '60px',
              transform: 'rotate(-30deg)',
            }}
          />
          {!isSmall && (
            <Chicken
              style={{
                position: 'absolute',
                top: '40px',
                right: '60px',
                transform: 'rotate(-30deg)',
              }}
            />
          )}

          <FoodDelivery
            style={{
              position: 'absolute',
              top: '30%',
              right: '40%',
            }}
          />
          <Sparkle
            style={{
              position: 'absolute',
              top: '28%',
              right: '40%',
            }}
          />

          {!mobile && (
            <>
              <DotIcon
                style={{
                  position: 'absolute',
                  top: '18%',
                  left: '40%',
                }}
              />

              <DotIcon
                style={{
                  position: 'absolute',
                  top: '38%',
                  right: '20%',
                  width: '20px',
                  height: '20px',
                }}
                fill='#D61D4F'
              />

              <DotIcon
                style={{
                  position: 'absolute',
                  bottom: '40%',
                  right: '50%',
                  width: '20px',
                  height: '20px',
                }}
                fill='#fa9418'
              />

              <CircleIcon
                stroke='#fff'
                style={{
                  position: 'absolute',
                  top: '18%',
                  right: '30%',
                  width: '20px',
                  height: '20px',
                }}
              />

              <CircleIcon
                stroke='#fff'
                style={{
                  position: 'absolute',
                  bottom: '18%',
                  right: '60%',
                  width: '20px',
                  height: '20px',
                }}
              />
            </>
          )}
        </Box>

        <Drinks
          style={{
            position: 'absolute',
            top: '8%',
            right: '40%',
            transform: 'rotate(30deg)',
          }}
        />

        <DotIcon
          style={{
            position: 'absolute',
            bottom: '38%',
            left: '50%',
            width: '20px',
            height: '20px',
          }}
        />
      </Flex>
      <Box className='landing-section'>
        <Box className='logo-section'>
          <Image width={160} height={160} src={clamorlogo} fit='contain' />
          <TagLine
            width='100%'
            height='60'
            style={{
              marginTop: '20px',
            }}
          />
        </Box>

        <Image className='prepare-order-section' src={PrepareOrder} fit='contain' />
      </Box>
    </Box>
  );
};

export default Landing;
